import HeaderDashboard from "../../Components/HeaderDashboard"
import { useState, useEffect } from 'react'
import { useLandingContext } from "../../Context"
import Styled from './feedbacks.module.css'
import { FiPlusCircle, FiMessageSquare, FiTrash } from 'react-icons/fi'
import { FaQuoteLeft, FaQuoteRight } from 'react-icons/fa'
import { TextArea, InputText, FormGroup, LabelText, Button } from '../../Components/Global'
import { FeedBack } from '../../Context/types'
import Footer from "../../Components/Footer"
import empty from '../../Assets/server-woman-colour.svg'
import Loading from "../../Components/Loading"

function Feedbacks() {

    const [name, setName] = useState('')
    const [feedBack, setFeedBack] = useState('')

    const useLanding = useLandingContext()

    function handleClearInputs() {
        setName('')
        setFeedBack('')
    }

    useEffect(() => {
        useLanding.handleGetFeedBacks()
        // eslint-disable-next-line
    }, [])

    return (
        <>
            {useLanding.loading && <Loading />}
            <HeaderDashboard page="feedbacks" />
            <section className={Styled.container_feedBacks}>
                <form className={Styled.content_add_feedBacks} onSubmit={e => {
                    e.preventDefault()
                    useLanding.handleAddFeedBacks(name, feedBack)
                    handleClearInputs()
                }}>
                    <h3>
                        <FiMessageSquare />
                        Novo
                    </h3>
                    <FormGroup className={Styled.form_group}>
                        <LabelText htmlFor="nameFeed">Nome:</LabelText>
                        <InputText maxLength={100} type="text" id="nameFeed" placeholder="Digite o nome aqui" value={name} onChange={e => setName(e.target.value)} />
                    </FormGroup>
                    <FormGroup className={Styled.form_group}>
                        <LabelText htmlFor="feedBack">FeedBack:</LabelText>
                        <TextArea maxLength={3000} id="feedBack" value={feedBack} placeholder="Escreva o comentario aqui" onChange={e => setFeedBack(e.target.value)} />
                    </FormGroup>
                    <Button width={17} height={3} type="submit">
                        <FiPlusCircle />
                        Adicionar
                    </Button>
                </form>
                <ul className={Styled.content_view_feedBacks}>
                    {useLanding.feedBacks.length > 0 ?

                        useLanding.feedBacks.map((feedback: FeedBack, index: number) => {

                            return (
                                <li key={`feed_${index.toString()}`}>
                                    <button type="button" onClick={() => useLanding.handleDeleteFeedback(feedback.id)}>
                                        <FiTrash />
                                    </button>
                                    <p>{feedback.name}</p>
                                    <p><FaQuoteLeft /> <span>{feedback.feedBack}</span><FaQuoteRight /></p>
                                </li>
                            )
                        })
                        : <img className={Styled.img_empty} src={empty} alt="Nada a ser exibido." />}
                </ul>
            </section>
            <Footer />
        </>
    )
}

export default Feedbacks